export const GET_STORE_PICKUP_LOCATIONS_START = 'GET_STORE_PICKUP_LOCATIONS_START';
export const GET_STORE_PICKUP_LOCATIONS_SUCCESS = 'GET_STORE_PICKUP_LOCATIONS_SUCCESS';
export const GET_STORE_PICKUP_LOCATIONS_FAILED = 'GET_STORE_PICKUP_LOCATIONS_FAILED';

export const SET_NEW_LOCATION_VALUE = 'SET_NEW_LOCATION_VALUE';
export const REMOVE_LOCATION_VALUE = 'REMOVE_LOCATION_VALUE';

export const ADD_STORE_PICKUP_LOCATION_STATUS = 'ADD_STORE_PICKUP_LOCATION_STATUS';
export const TRIGGER_STORE_PICKUP_ENABLE = 'TRIGGER_STORE_PICKUP_ENABLE';

export const ADD_STORE_PICKUP_LOCATION_START = 'ADD_STORE_PICKUP_LOCATION_START';
export const ADD_STORE_PICKUP_LOCATION_SUCCESS = 'ADD_STORE_PICKUP_LOCATION_SUCCESS';
export const ADD_STORE_PICKUP_LOCATION_FAILED = 'ADD_STORE_PICKUP_LOCATION_FAILED';

export const CANCEL_ADD_STORE_PICKUP_LOCATION = 'CANCEL_ADD_STORE_PICKUP_LOCATION';

export const UPDATE_STORE_PICKUP_LOCATION_START = 'UPDATE_STORE_PICKUP_LOCATION_START';
export const UPDATE_STORE_PICKUP_LOCATION_SUCCESS = 'UPDATE_STORE_PICKUP_LOCATION_SUCCESS';
export const UPDATE_STORE_PICKUP_LOCATION_FAILED = 'UPDATE_STORE_PICKUP_LOCATION_FAILED';

export const DELETE_STORE_PICKUP_LOCATION_START = 'DELETE_STORE_PICKUP_LOCATION_START';
export const DELETE_STORE_PICKUP_LOCATION_SUCCESS = 'DELETE_STORE_PICKUP_LOCATION_SUCCESS';
export const DELETE_STORE_PICKUP_LOCATION_FAILED = 'DELETE_STORE_PICKUP_LOCATION_FAILED';

export const GET_STORE_PICKUP_CONFIG_START = 'GET_STORE_PICKUP_CONFIG_START';
export const GET_STORE_PICKUP_CONFIG_SUCCESS = 'GET_STORE_PICKUP_CONFIG_SUCCESS';
export const GET_STORE_PICKUP_CONFIG_FAILED = 'GET_STORE_PICKUP_CONFIG_FAILED';

export const UPDATE_STORE_PICKUP_CONFIG_START = 'UPDATE_STORE_PICKUP_CONFIG_START';
export const UPDATE_STORE_PICKUP_CONFIG_SUCCESS = 'UPDATE_STORE_PICKUP_CONFIG_SUCCESS';
export const UPDATE_STORE_PICKUP_CONFIG_FAILED = 'UPDATE_STORE_PICKUP_CONFIG_FAILED';

export const getStorePickupLocationsStart = () => ({
  type: GET_STORE_PICKUP_LOCATIONS_START
});

export const getStorePickupLocationsSuccess = (data) => ({
  type: GET_STORE_PICKUP_LOCATIONS_SUCCESS,
  data
});

export const getStorePickupLocationsFailed = (error) => ({
  type: GET_STORE_PICKUP_LOCATIONS_FAILED,
  error
});

export const setNewLocationValue = (keyName, value) => ({
  type: SET_NEW_LOCATION_VALUE,
  keyName,
  value
});

export const removeLocationValue = (keyName) => ({
  type: REMOVE_LOCATION_VALUE,
  keyName
});

export const addStorePickupLocationStatus = (status) => ({
  type: ADD_STORE_PICKUP_LOCATION_STATUS,
  status
});

export const triggerStorePickupEnable = (status) => ({
  type: TRIGGER_STORE_PICKUP_ENABLE,
  status
});

export const addStorePickupLocationStart = () => ({
  type: ADD_STORE_PICKUP_LOCATION_START
});

export const addStorePickupLocationSuccess = (data) => ({
  type: ADD_STORE_PICKUP_LOCATION_SUCCESS,
  data
});

export const addStorePickupLocationFailed = (error) => ({
  type: ADD_STORE_PICKUP_LOCATION_FAILED,
  error
});

export const updateStorePickupLocationStart = () => ({
  type: UPDATE_STORE_PICKUP_LOCATION_START
});

export const updateStorePickupLocationSuccess = (data) => ({
  type: UPDATE_STORE_PICKUP_LOCATION_SUCCESS,
  data
});

export const updateStorePickupLocationFailed = (error) => ({
  type: UPDATE_STORE_PICKUP_LOCATION_FAILED,
  error
});

export const deleteStorePickupLocationStart = () => ({
  type: DELETE_STORE_PICKUP_LOCATION_START
});

export const deleteStorePickupLocationSuccess = (id) => ({
  type: DELETE_STORE_PICKUP_LOCATION_SUCCESS,
  id
});

export const deleteStorePickupLocationFailed = (error) => ({
  type: DELETE_STORE_PICKUP_LOCATION_FAILED,
  error
});

export const getStorePickupConfigStart = () => ({
  type: GET_STORE_PICKUP_CONFIG_START
});

export const getStorePickupConfigSuccess = (data) => ({
  type: GET_STORE_PICKUP_CONFIG_SUCCESS,
  data
});

export const getStorePickupConfigFailed = (error) => ({
  type: GET_STORE_PICKUP_CONFIG_FAILED,
  error
});

export const updateStorePickupConfigStart = () => ({
  type: UPDATE_STORE_PICKUP_CONFIG_START
});

export const updateStorePickupConfigSuccess = (data) => ({
  type: UPDATE_STORE_PICKUP_CONFIG_SUCCESS,
  data
});

export const updateStorePickupConfigFailed = (error) => ({
  type: UPDATE_STORE_PICKUP_CONFIG_FAILED,
  error
});

export const cancelAddStorePickupLocation = () => ({
  type: CANCEL_ADD_STORE_PICKUP_LOCATION
});
